import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumbs = ({ items }) => (
  <nav className="flex items-center flex-wrap gap-1.5 text-[13px] text-slate-500" aria-label="Breadcrumb" data-testid="breadcrumbs">
    {items.map((it, i) => {
      const last = i === items.length - 1;
      return (
        <span key={it.path} className="flex items-center gap-1.5">
          {last ? (
            <span className="text-slate-700 font-semibold">{it.name}</span>
          ) : (
            <Link to={it.path} className="hover:text-[var(--mk-blue)] transition-colors">{it.name}</Link>
          )}
          {!last && <ChevronRight className="w-3.5 h-3.5 text-slate-300" />}
        </span>
      );
    })}
  </nav>
);

export default Breadcrumbs;
